<form class="pw-form" (ngSubmit)="submit()" novalidate>
  <label class="pw-label" for="pw-new" dir="auto">{{ 'passwordPromptNew' | translate }}</label>
  <div class="pw-field">
    <input
      id="pw-new"
      name="newPassword"
      class="pw-input"
      [type]="showPassword ? 'text' : 'password'"
      autocomplete="new-password"
      [(ngModel)]="password"
      [attr.aria-invalid]="submitted && (!check.length || !check.mix)"
      autofocus
    />
    <button type="button" class="pw-toggle" (click)="toggleShow()" [attr.aria-pressed]="showPassword">
      {{ (showPassword ? 'passwordPromptHide' : 'passwordPromptShow') | translate }}
    </button>
  </div>

  <label class="pw-label" for="pw-confirm" dir="auto">{{ 'passwordPromptConfirm' | translate }}</label>
  <div class="pw-field">
    <input
      id="pw-confirm"
      name="confirmPassword"
      class="pw-input"
      [type]="showPassword ? 'text' : 'password'"
      autocomplete="new-password"
      [(ngModel)]="confirm"
      [attr.aria-invalid]="submitted && !check.match"
    />
  </div>

  <ul class="pw-rules" aria-live="polite">
    <li [class.pw-rule--ok]="check.length" dir="auto">{{ 'passwordPromptRuleLength' | translate: { min: minLength } }}</li>
    <li [class.pw-rule--ok]="check.mix" dir="auto">{{ 'passwordPromptRuleMix' | translate }}</li>
    <li [class.pw-rule--bad]="commonBad" dir="auto">
      {{ (commonBad ? 'passwordPromptRuleCommonBad' : 'passwordPromptRuleCommonPending') | translate }}
    </li>
    @if (confirm) {
      <li [class.pw-rule--ok]="check.match" [class.pw-rule--bad]="!check.match" dir="auto">
        {{ (check.match ? 'passwordPromptMatch' : 'passwordPromptMismatch') | translate }}
      </li>
    }
  </ul>

  @if (failureKey) {
    <p class="pw-error" role="alert" dir="auto">{{ failureKey | translate }}</p>
  } @else if (submitted && !check.valid) {
    <p class="pw-error" role="alert" dir="auto">{{ 'passwordPromptFixRules' | translate }}</p>
  }

  <!-- The host's own messages (e.g. a refused snooze). -->
  <ng-content select="[pwMessage]"></ng-content>

  <div class="pw-actions">
    <!-- The host's extra buttons (e.g. "Not now"); it hides them itself while notAvailable. -->
    <ng-content select="[pwAction]"></ng-content>
    @if (notAvailable) {
      <button type="button" class="pw-btn" (click)="continueAnyway()">{{ continueKey | translate }}</button>
    } @else {
      <button type="submit" class="pw-btn" [disabled]="busy">
        @if (busy) {
          <span class="pw-spinner" aria-hidden="true"></span>
          {{ 'passwordPromptSaving' | translate }}
        } @else {
          {{ 'passwordPromptSubmit' | translate }}
        }
      </button>
    }
  </div>
</form>
